<div class="mb-3" *ngIf="selectedPromoter.photoFullPath != ''">
    <img class="img-slideshow" [src]="selectedPromoter.photoFullPath + '?w=1920'" [alt]="selectedPromoter.postedFileName">
</div>

<div class="container-md">

    <div class="row my-4">
        <div class="col-2 col-lg-1" *ngIf="selectedPromoter.logoFullPath != ''">
            <img class="logo" [src]="selectedPromoter.logoFullPath + '?w=300'" alt="Logo">
        </div>
        <div class="col-10 col-lg-11">
            <h1>{{ selectedPromoter.promoterDataList[0].title }}</h1>
        </div>
    </div>
    <div class="row my-4">
        <div class="col-12">
            <div
                class="static-page"
                *ngIf="selectedPromoter != null"
                [innerHTML]="selectedPromoter.promoterDataList[0].subTitle">
            </div>
        </div>
    </div>
    <div class="row my-4 pe-4" *ngIf="selectedPromoter.showAmount">
        <div class="col-12 totalAmount">
            {{'IDS_TOTAL_AMOUNT' | translate }}<b>{{ selectedPromoter.totalAmount | number: '1.2-2' }} €</b>
        </div>
    </div>
</div>
<div class="main-container">
    <div class="container-md">
        <app-bid-search-result
            *ngIf="isLoaded"
            [memorabidAuctions]="memorabidAuctions"
            [marketplaceAuctions]="marketplaceAuctions"
            [memorabidAuctionsCount]="memorabidAuctions.length"
            [marketplaceAuctionsCount]="marketplaceAuctions.length"
            [isBidBoxLarge]="true"
            [idAuctionList]="idAuctionList"
            (auctionStatusFilterChanged)="onAuctionStatusFilterChanged($event)">
        </app-bid-search-result>
    </div>
</div>
